// extracted by mini-css-extract-plugin
export var fullHeightState = "_g-7";
export var headerCell = "_g-1";
export var loadingStateCell = "_g-4";
export var rowWrapper = "_g-3";
export var standaloneTable = "_g-8";
export var standaloneTableWithBodyFill = "_g-9";
export var stateCell = "_g-5";
export var table = "_g-0";
export var tableBodyFiller = "_g-6";
export var white = "_g-2";